import { INIT } from './actions';

const initialState = {

};

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case INIT: {

            return {
                ...state,
                settings: action.data
            }
        }

        default: {
            return state
        };
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/services/store/reducers/settings/index.js